import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=3d6f7e0a&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=3d6f7e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6f7e0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalsPlatformModal: require('/home/travis/build/Polumathes/LTNG-Transact-Frontend/components/Modals/PlatformModal.vue').default})
